
import { Command } from 'commander'
import { createLogger } from 'yam-operator/util'

const log = createLogger('cli')

export function addCloudCommands(program: Command): void {

  const subProgram = program.command('cloud')

  subProgram.command('login')
    .option('-t, --token [token]', 'The API token')
    .option('-u, --url [url]', 'The YAM Server URL', 'https://yam.plus')
    .action(({ token, url }) => {
      log.info(`[YAM Cloud] login: ${url}`)
    })

  subProgram.command('logout')

  subProgram.command('lock')

  subProgram.command('unlock')

  // get or list apps
  subProgram.command('apps')

  // get or list app releases
  subProgram.command('releases')
}
